export const getActionException = (exception) => {
  if (exception === undefined) {
    return undefined;
  }

  switch (true) {
    case exception.includes(
      ACTION_EXCEPTIONS.SIGNATURE_IS_NOT_AVAILABLE_EXCEPTION
    ):
      return ACTION_EXCEPTIONS.SIGNATURE_IS_NOT_AVAILABLE_EXCEPTION;
    case exception.includes(
      ACTION_EXCEPTIONS.LOAN_ONBOARDINGS_ARE_NOT_COMPLETED_EXCEPTION
    ):
      return ACTION_EXCEPTIONS.LOAN_ONBOARDINGS_ARE_NOT_COMPLETED_EXCEPTION;
    case exception.includes(
      ACTION_EXCEPTIONS.INVALID_LOAN_STATUS_FOR_SIGNATURE_CREATION_EXCEPTION
    ):
      return ACTION_EXCEPTIONS.INVALID_LOAN_STATUS_FOR_SIGNATURE_CREATION_EXCEPTION;
    case exception.includes(
      ACTION_EXCEPTIONS.INVALID_DOCUMENT_NUMBER_EXCEPTION
    ):
      return ACTION_EXCEPTIONS.INVALID_DOCUMENT_NUMBER_EXCEPTION;
    case exception.includes(
      ACTION_EXCEPTIONS.INVALID_ELECTRONIC_ID_INFORMATION_EXCEPTION
    ):
      return ACTION_EXCEPTIONS.INVALID_ELECTRONIC_ID_INFORMATION_EXCEPTION;
    case exception.includes(ACTION_EXCEPTIONS.INVALID_DATE_EXCEPTION):
      return ACTION_EXCEPTIONS.INVALID_DATE_EXCEPTION;
    case exception.includes(ACTION_EXCEPTIONS.INVALID_ISO3166_EXCEPTION):
      return ACTION_EXCEPTIONS.INVALID_ISO3166_EXCEPTION;
    case exception.includes(
      ACTION_EXCEPTIONS.USER_DETAILS_DOCUMENT_NUMBER_DOES_NOT_MATCH_KYC_EXCEPTION
    ):
      return ACTION_EXCEPTIONS.USER_DETAILS_DOCUMENT_NUMBER_DOES_NOT_MATCH_KYC_EXCEPTION;
    case exception.includes(
      ACTION_EXCEPTIONS.INVALID_DOWN_PAYMENT_CHECKOUT_SESSION_STATUS_FOR_SIGNATURE_CREATION_EXCEPTION
    ):
      return ACTION_EXCEPTIONS.INVALID_DOWN_PAYMENT_CHECKOUT_SESSION_STATUS_FOR_SIGNATURE_CREATION_EXCEPTION;

    default:
      return undefined;
  }
};

export const ACTION_EXCEPTIONS = {
  SIGNATURE_IS_NOT_AVAILABLE_EXCEPTION: "SignatureIsNotAvailableException",
  LOAN_ONBOARDINGS_ARE_NOT_COMPLETED_EXCEPTION:
    "LoanOnboardingsAreNotCompletedException",
  INVALID_LOAN_STATUS_FOR_SIGNATURE_CREATION_EXCEPTION:
    "InvalidLoanStatusForSignatureCreationException",
  INVALID_DOCUMENT_NUMBER_EXCEPTION: "InvalidDocumentNumberException",
  INVALID_ELECTRONIC_ID_INFORMATION_EXCEPTION:
    "InvalidElectronicIdinformationException",
  INVALID_ISO3166_EXCEPTION: "InvalidISO3166Exception",
  INVALID_DATE_EXCEPTION: "InvalidDateException",
  LOAN_DOESNT_HAVE_LOAN_APPLICATION_WITH_LOAN_APPLICATION_STATUS_SELECTED_EXCEPTION:
    "LoanDoesntHaveLoanApplicationWithLoanApplicationStatusSelectedException",
  INVALID_DOWN_PAYMENT_CHECKOUT_SESSION_STATUS_FOR_SIGNATURE_CREATION_EXCEPTION:
    "InvalidDownPaymentCheckoutSessionStatusForSignatureCreationException",
  USER_DETAILS_DOCUMENT_NUMBER_DOES_NOT_MATCH_KYC_EXCEPTION:
    "UserDetailsDocumentNumberDoesNotMatchKycException",
};

export const NON_CRITICAL_ACTION_EXCEPTIONS_BY_REQUEST_NAME = {
  REQUEST_POST_LOAN_APPLICATIONS_REJECTED: [
    ACTION_EXCEPTIONS.LOAN_ONBOARDINGS_ARE_NOT_COMPLETED_EXCEPTION,
  ],
  REQUEST_GET_SIGNATURE_PARAMS_BY_LOAN_ID_REJECTED: [
    ACTION_EXCEPTIONS.SIGNATURE_IS_NOT_AVAILABLE_EXCEPTION,
    ACTION_EXCEPTIONS.INVALID_DOWN_PAYMENT_CHECKOUT_SESSION_STATUS_FOR_SIGNATURE_CREATION_EXCEPTION,
  ],
  REQUEST_GET_SIGNATURE_URL_BY_LOAN_ID: [
    ACTION_EXCEPTIONS.SIGNATURE_IS_NOT_AVAILABLE_EXCEPTION,
    ACTION_EXCEPTIONS.INVALID_LOAN_STATUS_FOR_SIGNATURE_CREATION_EXCEPTION,
    ACTION_EXCEPTIONS.INVALID_DOWN_PAYMENT_CHECKOUT_SESSION_STATUS_FOR_SIGNATURE_CREATION_EXCEPTION,
  ],
};
